import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {GET_CLIENTS } from "./actionTypes"
import { getClientsSuccess, getClientsFail,getClientsLoading } from "./action"

//Include Both Helper File with needed methods
import { getClient, clientStatus } from "helpers/backend_helper"

function* fetchTasks() {
  try {
    yield put(getClientsLoading(true))
    const response = yield call(getClient)
    yield put(getClientsSuccess(response.client))
    // console.log(response.client,"responseresponse")
    yield put(getClientsLoading(false))
  } catch (error) {
    yield put(getClientsFail(error))
  }
}

function* clientList() {
  yield takeEvery(GET_CLIENTS, fetchTasks)
}

export default clientList